import { useEffect, useState } from 'react';

const cssUrl = (src) => `url("${String(src).replace(/"/g, '\\"')}")`;

/**
 * Defers large hero background downloads so first paint is not blocked.
 */
const LazyHeroBg = ({ src, className, fetchPriority = 'auto' }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(false);
    const img = new Image();
    img.decoding = 'async';
    if (fetchPriority === 'high' && 'fetchPriority' in img) {
      img.fetchPriority = 'high';
    }
    img.onload = () => setLoaded(true);
    img.onerror = () => setLoaded(true);
    img.src = src;
    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [src, fetchPriority]);

  return (
    <div
      className={`${className}${loaded ? ' is-loaded' : ''}`}
      style={loaded ? { backgroundImage: cssUrl(src) } : undefined}
      aria-hidden="true"
    />
  );
};

export default LazyHeroBg;
